"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _constants = require("./constants");

var _EspSync = _interopRequireDefault(require("./EspSync"));

var _handleActions;

var initialState = new _EspSync.default();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchEspSyncActionType.SUCCESS, function (state, action) {
  return new _EspSync.default(action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _actions.RemoveLastEspSyncErrorActionType.SUCCESS, function (state) {
  return state.remove(_constants.ESP_LAST_ERROR);
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateEspSyncActionType.SUCCESS, function (state, action) {
  return new _EspSync.default(action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchMailchimpSyncStatusActionType.SUCCESS, function (state, action) {
  return state.set(_constants.MAILCHIMP_SYNC_STATUS, action.payload.data.syncEnabled);
}), (0, _defineProperty2.default)(_handleActions, _actions.setMailchimpSyncStatusActionType.SUCCESS, function (state, action) {
  return state.set(_constants.MAILCHIMP_SYNC_STATUS, action.payload.props);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;